

<template>
    <img v-if="imageSrc" :src="imageSrc" alt="">
    <div v-else></div>
</template>

<style scoped>

</style>

<script setup lang="ts">

import {useApi} from "@/composables/useApi";

const props = defineProps({
    src: {
        type: String,
        required: true,
    }
})

const imageSrc = useState<string>('images.'+props.src, () => '');

onMounted(async () => {
    getImage();
});

watch(() => props.src, () => {
    getImage();
});

async function getImage() {
    if(!props.src) {
        imageSrc.value = '';
        return;
    }

    const imageLoading = useState<boolean>('images.loading.'+props.src, () => false);
    if(imageLoading.value || imageSrc.value !== '') {
        return;
    }

    imageLoading.value = true;

    const { data: image, loading, fetch } = useApi<Blob>({
        url: props.src?.substring(1), // gets rid of initial "/" as both baseUrl and image.url include a "/"
        method: 'GET',
    });

    await fetch();

    if(image.value) {
        imageSrc.value = URL.createObjectURL(image.value);
    }
    imageLoading.value = true;
}

</script>